/**
 * Creates a constant function that always returns the same value.
 *
 * Const with a 'k' because 'const' is already a keyword.
 * @param {*} x - The constant value.
 * @returns {Function} A function that always returns `x`.
 * @see {@link https://en.wikipedia.org/wiki/Constant_function|Wikipedia}
 */
export function konst (x) { return () => x; }

/**
 * A function that always returns true.
 *
 * @return {Boolean} `true`
 */
export const trueFn = konst(true);

/**
 * A function that always returns false.
 *
 * @return {Boolean} `false`
 */
export const falseFn = konst(false);
